// Import style
import { ErrorMessageText, ErrorMessageStackContainer } from './style';

// Error message
export function ErrorMessage({ message, critical = false }) {
    return <ErrorMessageText critical={critical}>{message}</ErrorMessageText>;
}

// Error message stack
export function ErrorMessageStack({ errorMessages = [] }) {
    if (!errorMessages.length) return null;

    return (
        <ErrorMessageStackContainer>
            {errorMessages.map(({ message, critical }, index) => (
                <ErrorMessage
                    key={index}
                    critical={critical}
                    message={message}
                />
            ))}
        </ErrorMessageStackContainer>
    );
}
